<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<template>
	<v-card>
    <v-tabs
      color="primary"
			bg-color="background"
      center-active
    >
      <v-tab @click="router.push('/admin/word/update')">Update</v-tab>
      <v-tab @click="router.push('/admin/word/update')">Delete</v-tab>
      <v-tab @click="router.push('/admin/word/update')">Insert</v-tab>
    </v-tabs>
  </v-card>
  <router-view/>
</template>

<style scoped>
</style>